import { createHoldingBookingMutation } from '@hcr/api/consumer'

import { HTTP_CONFIG } from '../../../../configs'

export const useHoldingBookingMutation = createHoldingBookingMutation(HTTP_CONFIG.API.Consumer.url)
